import bannerLink from "../../static/banner.png";

const mainFeaturedPost = {
    title: "Welcome! Alexa Community - Jaipur",
    description:
      "Alexa Dev Hub aims to provide resources and learning content all in one place to boost up your VUI developemnt skills. ",
    image: `${bannerLink}`,
    imgText: "main image description",
  };

export default mainFeaturedPost;